import { render } from "./FormBirthDate.vue?vue&type=template&id=622190eb&scoped=true&bindings={\"value\":\"props\",\"label\":\"props\",\"patternLabel\":\"props\",\"req\":\"props\",\"optional\":\"props\",\"error\":\"props\",\"fullYear\":\"props\",\"errorMessage\":\"props\",\"description\":\"props\",\"changeSelect\":\"setup\",\"setDate\":\"setup\",\"setYear\":\"setup\"}"
import script from "./FormBirthDate.vue?vue&type=script&lang=ts"
export * from "./FormBirthDate.vue?vue&type=script&lang=ts"

import "./FormBirthDate.vue?vue&type=style&index=0&id=622190eb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-622190eb"

export default script